import { useEffect, useState } from "react";
import { siteNav, updateTicker } from "@/mocks/anime";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkColor = scrolled ? "text-foreground-700" : "text-background-50";
  const linkHover = scrolled ? "hover:text-primary-600" : "hover:text-background-50";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="bg-primary-500 text-background-50 dark:text-foreground-950">
        <div className="flex items-center gap-3 px-4 md:px-6 h-8 overflow-hidden">
          <span className="flex items-center gap-1.5 shrink-0 text-xs font-medium">
            <i className="ri-flashlight-fill" />
            <span className="hidden sm:inline">更新条</span>
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee whitespace-nowrap text-xs">
              {[...updateTicker, ...updateTicker].map((item, idx) => (
                <span key={idx} className="mr-10 opacity-95">
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <nav className="flex items-center justify-between px-4 md:px-6 h-14">
        <a href="#top" className="flex items-center gap-2 shrink-0">
          <span
            className={`w-8 h-8 flex items-center justify-center rounded-md text-lg ${
              scrolled
                ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                : "bg-background-50 text-primary-600"
            }`}
          >
            <i className="ri-movie-2-line" />
          </span>
          <span
            className={`font-heading text-lg font-semibold tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            91动漫
          </span>
        </a>

        <div className="hidden md:flex items-center gap-7">
          {siteNav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`text-sm font-medium transition-colors cursor-pointer ${linkColor} ${linkHover}`}
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#ranking"
            className={`hidden md:inline-flex items-center gap-1.5 h-9 px-4 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
              scrolled
                ? "bg-primary-500 text-background-50 dark:text-foreground-950 hover:bg-primary-600"
                : "bg-background-50 text-primary-600 hover:bg-background-100"
            }`}
          >
            <i className="ri-trophy-line" />
            看排行榜
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md text-xl cursor-pointer ${
              scrolled ? "text-foreground-900 bg-background-100" : "text-background-50 bg-black/20"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 py-3">
          <div className="flex flex-col">
            {siteNav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="py-2.5 text-sm font-medium text-foreground-800 border-b border-background-100 last:border-none cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}